/* Lounelle — PDP storefront translations + locale polish.
 * Shopify Translate & Adapt remains the source of truth.
 * This bridge applies translated section settings to dynamic/custom-Liquid UI.
 */
(function () {
  'use strict';

  var polishScheduled = false;
  var observedFrenchRoots = new WeakSet();
  var DYNAMIC_PRICE_SELECTOR = '[data-product-price], [data-compare-price]';

  function readConfig() {
    var node = document.getElementById('LounellePdpI18n');
    if (!node) return null;

    try {
      var raw = JSON.parse(node.textContent || '{}');
      return {
        reviewTemplate: String(raw.reviewTemplate || ''),
        reassuranceShipping: String(raw.reassuranceShipping || ''),
        reassuranceExchanges: String(raw.reassuranceExchanges || ''),
        stockNote: String(raw.stockNote || ''),
        freeShipping: String(raw.freeShipping || ''),
        dispatchTemplate: String(raw.dispatchTemplate || ''),
        stockWarningHeading: String(raw.stockWarningHeading || ''),
        stockWarningBody: String(raw.stockWarningBody || ''),
        stockWarningEnd: String(raw.stockWarningEnd || ''),
        observedPriceTemplate: String(raw.observedPriceTemplate || ''),
        urgencyBadges: Array.isArray(raw.urgencyBadges) ? raw.urgencyBadges.map(function (value) { return String(value || ''); }) : [],
        zoomLabel: String(raw.zoomLabel || '')
      };
    } catch (_) {
      return null;
    }
  }

  function localeFrom(node) {
    var language = String((node && node.dataset && node.dataset.language) || document.documentElement.lang || 'fr').trim();
    var country = String((node && node.dataset && node.dataset.country) || '').trim().toUpperCase();
    var locale = country && language.indexOf('-') === -1 ? language + '-' + country : language;
    try {
      return Intl.NumberFormat.supportedLocalesOf([locale, language])[0] || language || 'fr';
    } catch (_) {
      return language || 'fr';
    }
  }

  function formatNumber(value, locale, options) {
    try { return new Intl.NumberFormat(locale, options || {}).format(value); }
    catch (_) { return String(value); }
  }

  function formatReview(score, config) {
    if (!score || !config.reviewTemplate) return;
    var rating = parseFloat(score.dataset.rating || '0');
    var count = parseInt(score.dataset.count || '0', 10);
    if (!(rating > 0) || !(count > 0)) return;

    var ratingNode = score.querySelector('[data-lounelle-review-rating]');
    var legacyCountNode = score.querySelector('.lounelle-review-score__count');
    if (!ratingNode) return;

    var locale = localeFrom(score);
    ratingNode.textContent = config.reviewTemplate
      .replace(/\[RATING\]/g, formatNumber(rating, locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 }))
      .replace(/\[COUNT\]/g, formatNumber(count, locale, { maximumFractionDigits: 0 }));

    if (legacyCountNode) legacyCountNode.hidden = true;
    score.dataset.lounelleReviewFormatted = 'true';
  }

  function collect(container, selector) {
    var nodes = [];
    if (!container) return nodes;
    if (container.matches && container.matches(selector)) nodes.push(container);
    if (container.querySelectorAll) Array.prototype.push.apply(nodes, container.querySelectorAll(selector));
    return nodes;
  }

  function applyNonFrenchCarrierIcon(scope) {
    if (isFrench()) return;
    var icon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3 7.5 12 3l9 4.5v9L12 21l-9-4.5v-9Z" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="m3.5 7.5 8.5 4.3 8.5-4.3M12 11.8V21" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
    collect(scope || document, '[data-lounelle-icon-block="icon_JfF7QK"] .product__icon__holder img').forEach(function (image) {
      if (image.dataset.lounelleCarrierIcon === 'neutral') return;
      image.dataset.lounelleCarrierIcon = 'neutral';
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(icon);
      image.alt = '';
    });
  }

  function applyReassurance(scope, config) {
    collect(scope || document, '[data-lounelle-reassurance-shipping]').forEach(function (node) {
      node.textContent = config.reassuranceShipping;
    });
    collect(scope || document, '[data-lounelle-reassurance-exchanges]').forEach(function (node) {
      node.textContent = config.reassuranceExchanges;
    });
  }

  function renderTemplateWithStrong(node, template, token, value) {
    if (!node || !template) return;
    var marker = '[' + token + ']';
    var index = template.indexOf(marker);
    node.replaceChildren();
    if (index === -1) {
      node.appendChild(document.createTextNode(template + (value ? ' ' + value : '')));
      return;
    }
    node.appendChild(document.createTextNode(template.slice(0, index)));
    var strong = document.createElement('strong');
    strong.textContent = value;
    node.appendChild(strong);
    node.appendChild(document.createTextNode(template.slice(index + marker.length)));
  }

  function dispatchDate(locale) {
    var date = new Date();
    date.setDate(date.getDate() + 1);
    try {
      return new Intl.DateTimeFormat(locale || undefined, { weekday: 'short', day: 'numeric', month: 'long' }).format(date);
    } catch (_) {
      return date.toLocaleDateString();
    }
  }

  function applyDynamicCopy(scope, config) {
    var container = scope || document;

    collect(container, '.lounelle-stock-note span:last-child').forEach(function (node) {
      if (config.stockNote) node.textContent = config.stockNote;
    });

    collect(container, '.ln-product-tag').forEach(function (node) {
      var index = parseInt(node.dataset.lounelleBadgeIndex || '', 10);
      if (!Number.isInteger(index)) {
        index = 0;
        node.dataset.lounelleBadgeIndex = String(index);
      }
      if (config.urgencyBadges[index]) node.textContent = config.urgencyBadges[index];
    });

    collect(container, '.ln-shipping-info__text').forEach(function (node) {
      renderTemplateWithStrong(node, config.dispatchTemplate, 'DATE', dispatchDate(localeFrom(node)));
    });

    collect(container, '.ln-shipping-info__free-text').forEach(function (node) {
      if (config.freeShipping) node.textContent = config.freeShipping;
    });

    collect(container, '.ln-stock-warning').forEach(function (node) {
      node.replaceChildren();
      if (config.stockWarningHeading) {
        var heading = document.createElement('strong');
        heading.textContent = config.stockWarningHeading;
        node.appendChild(heading);
        node.appendChild(document.createTextNode(' '));
      }
      if (config.stockWarningBody) {
        node.appendChild(document.createTextNode(config.stockWarningBody + ' '));
      }
      if (config.stockWarningEnd) {
        var ending = document.createElement('strong');
        ending.textContent = config.stockWarningEnd;
        node.appendChild(ending);
      }
    });

    collect(container, '[data-lounelle-benefit-text], .shipping-method-price > strong, .shipping-region-row > strong').forEach(function (node) {
      var text = (node.textContent || '').trim();
      if (config.freeShipping && (text === 'Livraison gratuite' || text === 'Free shipping')) {
        node.textContent = config.freeShipping;
      }
    });

    collect(container, '.lounelle-timer-secondary').forEach(function (node) {
      if (!config.freeShipping) return;
      var text = node.textContent || '';
      if (text.indexOf('Livraison gratuite') === 0) node.textContent = config.freeShipping + text.slice('Livraison gratuite'.length);
      if (text.indexOf('Free shipping') === 0) node.textContent = config.freeShipping + text.slice('Free shipping'.length);
    });
  }

  function walkText(root, transform) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var current = node.nodeValue || '';
      var next = transform(current);
      if (next !== current) node.nodeValue = next;
    }
  }

  function isFrench() {
    return String(document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  }

  function polishFrenchPrices(scope) {
    if (!isFrench()) return;
    collect(scope || document, DYNAMIC_PRICE_SELECTOR).forEach(function (node) {
      walkText(node, function (text) { return text.replace(/(\d)[ \u00a0]*€/g, '$1\u00a0€'); });
    });
  }

  function polishFrenchStatic(scope) {
    if (!isFrench()) return;
    var container = scope || document;

    collect(container, '.product__feature__heading h5').forEach(function (node) {
      if (node.textContent.trim() === "Besoin d'aide?") node.textContent = 'Besoin d’aide ?';
    });

    collect(container, '.product__feature__text a[href^="tel:+33"]').forEach(function (node) {
      var digits = (node.textContent || '').replace(/\s+/g, '');
      var match = digits.match(/^\+33([1-9])(\d{2})(\d{2})(\d{2})(\d{2})$/);
      if (match) node.textContent = '+33 ' + match.slice(1).join(' ');
    });

    collect(container, '.lounelle-promo-offer-text').forEach(function (node) {
      walkText(node, function (text) { return text.replace(/-(\d+)\s*%/g, '−$1\u00a0%'); });
    });
  }

  function polishFrench(scope) {
    polishFrenchPrices(scope);
    polishFrenchStatic(scope);
  }

  function apply(scope) {
    var config = readConfig();
    if (!config) return;
    window.LounellePdpI18n = config;

    var container = scope || document;
    collect(container, 'product-info').forEach(function (root) {
      root.dataset.lounelleZoomLabel = config.zoomLabel;
    });

    applyNonFrenchCarrierIcon(container);
    applyReassurance(container, config);
    applyDynamicCopy(container, config);
    collect(container, '[data-lounelle-review-score]').forEach(function (score) { formatReview(score, config); });
    polishFrench(container);
  }

  function mutationNeedsFrenchPricePolish(mutation) {
    var target = mutation.target && mutation.target.nodeType === Node.TEXT_NODE ? mutation.target.parentElement : mutation.target;
    if (target && target.closest && target.closest(DYNAMIC_PRICE_SELECTOR)) return true;
    if (mutation.addedNodes && mutation.addedNodes.length) {
      for (var i = 0; i < mutation.addedNodes.length; i += 1) {
        var added = mutation.addedNodes[i];
        if (added.nodeType !== Node.ELEMENT_NODE) continue;
        if ((added.matches && added.matches(DYNAMIC_PRICE_SELECTOR)) || (added.querySelector && added.querySelector(DYNAMIC_PRICE_SELECTOR))) return true;
      }
    }
    return false;
  }

  function scheduleFrenchPricePolish(scope) {
    if (!isFrench() || polishScheduled) return;
    polishScheduled = true;
    window.requestAnimationFrame(function () {
      polishScheduled = false;
      polishFrenchPrices(scope || document);
    });
  }

  function observeFrenchRoot(root) {
    if (!isFrench() || !root || observedFrenchRoots.has(root)) return;
    observedFrenchRoots.add(root);
    var observer = new MutationObserver(function (mutations) {
      if (mutations.some(mutationNeedsFrenchPricePolish)) scheduleFrenchPricePolish(root);
    });
    observer.observe(root, { childList: true, characterData: true, subtree: true });
  }

  function observeFrenchPolish(scope) {
    if (!isFrench()) return;
    collect(scope || document, 'product-info').forEach(observeFrenchRoot);
  }

  function boot() {
    apply(document);
    observeFrenchPolish(document);

    document.addEventListener('theme:product-info:loaded', function (event) {
      window.requestAnimationFrame(function () {
        var scope = event.target.closest('product-info') || event.target;
        apply(scope);
        observeFrenchPolish(scope);
      });
    });

    document.addEventListener('shopify:section:load', function (event) {
      window.requestAnimationFrame(function () {
        apply(event.target);
        observeFrenchPolish(event.target);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
